import {} from "./Node.js";
export function nodeKey(node) {
    return `${node.modId}/${node.name}#${node.id}`;
}
//# sourceMappingURL=nodeKey.js.map